import { render, staticRenderFns } from "./AccessGroup.vue?vue&type=template&id=1b3dc9c6&"
import script from "./AccessGroup.vue?vue&type=script&lang=js&"
export * from "./AccessGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports